import React from 'react'
import {Link} from 'react-router-dom'
import style from '../../style/style'

const Footer = () => (
    <nav style={ style.footer.layout }>
      <Link to="/" style={ style.footer.link }>
        Home
      </Link>
      <Link to="/tos" style={ style.footer.link }>
        Terms of service
      </Link>
      <Link to="/privacy" style={ style.footer.link }>
        Privacy policy
      </Link>
      <Link to="/sources" style={ style.footer.link }>
        Data sources
      </Link>
    </nav>
)

export default Footer;



// WEBPACK FOOTER //
// ./src/components/footer/index.js